import React from 'react';
import {Container, Row, Col, Nav, NavItem, NavLink} from 'reactstrap';
import Button from '../../components/Button/Button';
import {useTranslation, Trans} from 'react-i18next';

const Footer = () => {
  const {t} = useTranslation();

  return (
    <div className="app-bg-primary pt-5">
      <Container>
        <Row className="mb-4">
          <Col md={3} className="text-center text-md-left mb-4 mb-md-0">
            <img className="mb-4 mw-100" src={require('../../assets/images/logo-white.png')}/>
            <Nav vertical>
              <NavItem>
                <NavLink href="#" className="px-0 py-1 small text-muted text-uppercase">{t('footerItemLobby')}</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#" className="px-0 py-1 small text-muted text-uppercase">{t('footerItemGreenPavilion')}</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#" className="px-0 py-1 small text-muted text-uppercase">{t('footerItemGreenForums')}</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#" className="px-0 py-1 small text-muted text-uppercase">{t('footerItemB2B')}</NavLink>
              </NavItem>
            </Nav>
          </Col>


          <Col md={6} className="text-center mb-5 mb-md-0 text-md-left col-md-6 border-right border-left pl-5 pr-5">

            <h6 className="text-muted text-uppercase">{t('newsletterTitle')}</h6>
            <p className="small text-muted">{t('newsletterText')}</p>

            <div className="d-flex mt-4">
              <input type="text" placeholder={t('newsletterField')} className="px-3 mr-2 py-2 w-75"
                     style={{border: 'none', borderRadius: 50}}/>
              <Button
                text={t('sendBtn')}
                type="gradient"
                className="py-2"
              />
            </div>

          </Col>

          <Col md={3}>
            <div className="text-center text-md-right mb-5 mb-md-0">
              <a href="https://www.facebook.com/KosovoGreen">
                <img className="mb-4 mr-3" style={{maxWidth: '33%'}}
                     src={require('../../assets/images/fb.png')}/>
              </a>
              <a href="https://www.instagram.com/greenbusinesskosovo">
                <img className="mb-4 mr-3" style={{maxWidth: '33%'}}
                     src={require('../../assets/images/insta.png')}/>
              </a>
              <a href="https://www.linkedin.com/in/kosovo-manufacturing-club-8033b21a1/">
              <img className="mb-4" style={{maxWidth: '33%'}}
                   src={require('../../assets/images/in.png')}/>
              </a>
              <p className="mx-0 my-1 small text-muted">+383 45 666 461</p>
              <p className="mx-0 my-1 small text-muted">info@klubiprodhuesve.org</p>
              <p className="mx-0 my-1 small text-muted">www.klubiprodhuesve.org</p>
              <p className="mx-0 my-1 small text-muted">Prishtinë, Lorenc Antoni nr.21, 10.000 Kosovë</p>
            </div>
          </Col>
        </Row>
      </Container>

      <div className="footer1 w-100 pb-3 pt-1">
        <Container>
          <div className="small text-black text-center mt-3">All copyrights (C) Reserved. 2020</div>
          <img className="mx-auto mt-3 d-flex mb-2" style={{width: '100%', maxWidth: 250}}
               src={require('../../assets/images/klubi-logo.png')}/>
        </Container>
      </div>
    </div>
  );
}

export default Footer;